import { createMuiTheme } from '@material-ui/core/styles';

const alacuentaTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#b41b64',
    },
    secondary: {
      main: '#eeeeee',
    },
  }
});

export default alacuentaTheme;